import gql from 'graphql-tag';

export const GET_FEATURE_FLAGS = gql`
  query GetFeatureFlags($flags: [String!]!, $flagConfigs: [FeatureFlagInput!], $flipperId: String) {
    featureFlags(flags: $flags, flagConfigs: $flagConfigs, flipperId: $flipperId) {
      name
      featureFlagEnabled
      experimentEligible
      variant
    }
  }
`;
